import React from "react"
import { IconImage, LoaderWrapper, LoaderContainer } from "../../styles"
import loaderIcon from "../../icons/loading-icon.svg"

export default function Loader() {
  return (
    <LoaderWrapper>
      <LoaderContainer>
        <IconImage src={loaderIcon} alt="Loading" />
      </LoaderContainer>
    </LoaderWrapper>
  )
}
